export default {
	api: 'https://ust-testing.beautitag.com/eqc/api',
	loginTimeout: 86400
};
